import Analytics from 'analytics';
import { CONSTANTS } from './constants';
import ReactPixel from 'react-facebook-pixel';
import { clsx } from 'clsx';
import defaultImage from '@/images/default-image.png';
import googleAnalytics from '@analytics/google-analytics';
import { notify } from 'react-notify-toast';
import { twMerge } from 'tailwind-merge';

const disablePageScroll = (isDisable = true) => {
  const elHTML = document.querySelector('html');

  if (isDisable) elHTML.style.overflowY = 'hidden';
  else elHTML.style.removeProperty('overflow-y');
};

const discountAmount = (discount, maxAmount, total) => {
  const amount = Math.round(total * (discount / 100));
  const fixedAmount = amount > maxAmount ? maxAmount : amount;
  return fixedAmount;
};

const discountAmountFromCode = (voucherCode, subtotal) => {
  // This is a placeholder function for voucher-specific discount calculation
  // In a real app, this would fetch voucher details from API or cache
  // For now, we'll return 0 as a safe fallback
  console.warn('HELPERS.discountAmountFromCode called but not properly implemented');
  return 0;
};

function saveUTMParameters() {
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'];
  const urlParams = new URLSearchParams(window.location.search);

  utmParams.forEach((param) => {
    const value = urlParams.get(param);
    if (value) {
      sessionStorage.setItem(param, value);
      console.log(`Saved UTM parameter: ${param} = ${value}`);
    }
  });
}

function getUTMParameters() {
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'];
  const savedParams = {};
  
  utmParams.forEach((param) => {
    const value = sessionStorage.getItem(param);
    if (value) {
      savedParams[param] = value;
    }
  });
  
  return savedParams;
}

const copyText = (text, successMessage = 'Berhasil disalin') => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('Copy');
  textArea.remove();
  notify.show(successMessage, 'success', 3000);
};

export const handleClickWhatsapp = (e, contactPhone) => {
  e.preventDefault();
  ReactPixel.track('Contact', { method: 'Phone Call', contact_id: contactPhone });
  window.open(`https://wa.me/${parsePhone(contactPhone)}`, '_blank');
};

export const cn = (...inputs) => {
  return twMerge(clsx(inputs));
};

const handleShare = (eventTitle) => {
  const eventUrl = window.location.href;

  if (navigator.share) {
    navigator
      .share({
        title: eventTitle || 'Event',
        url: eventUrl,
      })
      .catch(() => {
        HELPERS.copyText(eventUrl, 'Gagal membagikan, link acara disalin');
      });
  } else {
    HELPERS.copyText(eventUrl, 'Link acara berhasil disalin');
  }
};

const truncateText = (text, maxLength = 10) => {
  let result = text.substr(0, maxLength);
  if (text.length > maxLength) result += '...';
  return result;
};

const handleBrokenImage = (e) => {
  e.target.src = defaultImage;
};

const queryStringToObject = (queryString) => {
  const pairs = queryString.substring(1).split('&');

  const array = pairs.map((el) => {
    const parts = el.split('=');
    return parts;
  });

  return Object.fromEntries(array);
};

// const numberFormat = (input) => {
//   const number = input.toString();
//   const split = number.split('').reverse();
//   const addDot = split.map((digit, index) => (index % 3 === 0 && index !== 0 ? `${digit}.` : digit));
//   const output = addDot.reverse().join('');

//   return output;
// };
const numberFormat = (input) => {
  if (!input) {
    return 0;
  }

  return new Intl.NumberFormat(['id']).format(input);
};

const objectToQueryString = (obj, isEncodeURI = false) => {
  return Object.keys(obj).reduce((str, value, i) => {
    const key = isEncodeURI ? encodeURIComponent(value) : value;
    const val = isEncodeURI ? encodeURIComponent(obj[key]) : obj[key];
    const delimiter = i === 0 ? '?' : '&';
    return [str, delimiter, key, '=', val].join('');
  }, '');
};

const removeQueryParams = (url, params) => {
  const object = queryStringToObject(url);
  if (params in object) delete object[params];
  const result = objectToQueryString(object);
  return result;
};

const showNotificationServiceError = (error) => {
  let notifyMessage = 'Terjadi Kesalahan';
  let notifyType = 'error';

  if (error) {
    if (error.response?.status === 500 || error.response?.status === 404) {
      notifyType = 'error';
      notifyMessage = `${error.response?.status} : ${error.response?.statusText}`;
    } else if (error.response?.data) {
      if (error.response?.data.errors) {
        notifyType = 'warning';
        notifyMessage = Object.values(error.response?.data.errors).map((message) => <div>{message}</div>);
      } else if (error.response?.data.message) {
        notifyType = 'warning';
        notifyMessage = error.response?.data.message;
      } else notifyType = 'error';
    }
  }

  return notify.createShowQueue()(notifyMessage, notifyType);
};

const showNotification = (message) => {
  const notifyMessage = message || 'Berhasil!';
  const notifyType = 'success';

  return notify.createShowQueue()(notifyMessage, notifyType);
};

const removeDuplicateObjectFromArray = (array) => {
  const objects = array.map(JSON.stringify);
  const uniqueSet = new Set(objects);
  const result = Array.from(uniqueSet).map(JSON.parse);

  return result;
};

const parsePhone = (number) => {
  if (number) {
    const result = number.replace(/[^+\d]+/g, '');
    return result;
  }
  return '';
};

const typeOfPurchasable = (productTypeId) => {
  let label = 'Pembayaran';
  let type = 'other';

  switch (productTypeId) {
    case CONSTANTS.PRODUCT_TYPE.COURSE.id:
      label = 'Pembelian Kursus';
      type = 'course';
      break;

    case CONSTANTS.PRODUCT_TYPE.SUBSCRIPTION_PACKAGE.id:
      label = 'Berlangganan';
      type = 'subscriptionPackage';
      break;

    case CONSTANTS.PRODUCT_TYPE.LEARNING_PROGRAM.id:
      label = 'Pembelian Program Belajar';
      type = 'learningPath';
      break;

    default:
      label = 'Pembayaran';
      type = 'other';
      break;
  }

  return { label, type };
};

const GA = Analytics({
  app: process.env.REACT_APP_NAME,
  plugins: [
    googleAnalytics({
      measurementIds: [process.env.REACT_APP_GOOGLE_ANALYTIC],
    }),
  ],
});

const sendEventGA = (eventName, params = {}) => {
  GA.track(eventName, params);
};

const getMonthNumber = (monthStr) => {
  const standardMonth = monthStr.toLowerCase().substring(0, 3);

  const monthMap = {
    jan: '01',
    feb: '02',
    mar: '03',
    apr: '04',
    mei: '05',
    jun: '06',
    jul: '07',
    agu: '08',
    ags: '08',
    sep: '09',
    okt: '10',
    nov: '11',
    des: '12',

    may: '05',
    aug: '08',
    oct: '10',
    dec: '12',
  };

  const result = monthMap[standardMonth];
  if (!result) {
    throw new Error(`Invalid month string: ${monthStr}`);
  }

  return result;
};

const getCookieValue = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return null;
};

export const calculateEventDisplayPrice = (event) => {
  if (!event) return 0;

  const ticketPrice = Number(event.ticket_price) || 0;
  const sellPriceValue = Number(event.sell_price) || 0;
  const discountValue = Number(event.discount) || 0;
  const earlyBirdPriceValue = Number(event.early_ticket_price) || 0;
  const earlyBirdDate = event.early_ticket_date;

  const isEarlyBirdDateValid = (dateStr) => {
    if (!dateStr) return false;
    try {
      const validUntil = new Date(dateStr);
      const currentDate = new Date();
      return currentDate <= validUntil && !Number.isNaN(validUntil.getTime());
    } catch (error) {
      return false;
    }
  };

  const useEarlyBirdPrice =
    earlyBirdPriceValue > 0 && earlyBirdPriceValue < ticketPrice && isEarlyBirdDateValid(earlyBirdDate);

  let finalDisplayPrice;

  if (useEarlyBirdPrice) {
    finalDisplayPrice = earlyBirdPriceValue;
  } else if (sellPriceValue > 0) {
    finalDisplayPrice = sellPriceValue;
  } else {
    finalDisplayPrice = discountValue > 0 ? ticketPrice * (1 - discountValue / 100) : ticketPrice;
  }

  return Math.round(finalDisplayPrice);
};

export const getGAVisitorId = () => {
  try {
    const user = GA.user();
    if (user?.anonymousId) {
      return user.anonymousId;
    }

    const gaCookie = document.cookie.match(/_ga=GA\d\.\d\.(\d+\.\d+)/);
    if (gaCookie && gaCookie[1]) {
      return gaCookie[1];
    }

    const VISITOR_ID_KEY = 'fp_visitor_id';
    let visitorId = localStorage.getItem(VISITOR_ID_KEY);

    if (!visitorId) {
      visitorId = `${Date.now()}.${Math.random().toString(36).substring(2, 15)}`;
      localStorage.setItem(VISITOR_ID_KEY, visitorId);

      if (typeof GA !== 'undefined' && GA.identify) {
        GA.identify(visitorId);
      }
    }

    return visitorId;
  } catch (error) {
    console.error('Error getting visitor ID:', error);
    return `fallback_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  }
};

export const HELPERS = {
  GA,
  disablePageScroll,
  copyText,
  parsePhone,
  sendEventGA,
  numberFormat,
  discountAmount,
  discountAmountFromCode,
  handleBrokenImage,
  truncateText,
  handleClickWhatsapp,
  queryStringToObject,
  objectToQueryString,
  removeQueryParams,
  typeOfPurchasable,
  getMonthNumber,
  showNotificationServiceError,
  showNotification,
  removeDuplicateObjectFromArray,
  getCookieValue,
  handleShare,
  cn,
  saveUTMParameters,
  getUTMParameters,
  calculateEventDisplayPrice,
  getGAVisitorId,
};
